import { TrackLocation } from './TrackLocation'

export enum TrackType {
  Circuit = 'circuit',
  Sprint = 'sprint',
  Hillclimb = 'hillclimb',
  Drag = 'drag',
  RoadCourse = 'road-course',
  AutocrossAutosolo = 'autocross-autosolo',
  Unknown = 'unknown',
}

export enum SurfaceType {
  Asphalt = 'asphalt',
  Concrete = 'concrete',
  Gravel = 'gravel',
  Dirt = 'dirt',
  Mixed = 'mixed',
}

export interface TrackMetadata {
  trackId: string
  trackName: string
  location: TrackLocation
  lengthMeters?: number
  turns?: number
  direction?: 'clockwise' | 'counterclockwise'
  type: TrackType
  surfaces?: SurfaceType[]
  notes?: string
}
